import { httpClient } from '../http/httpClient'

export async function userPasswordUpdate(passwordData: string, id: string) {
  const { data } = await httpClient.patch(`/user/${id}/password`, {
    password: passwordData,
  })

  return data
}
